import { createSelector } from 'reselect';

const selectEDocs = (state: any) => state.eDocs;


export const selectEDocsCurrentItem = createSelector([selectEDocs], (eDocs) => eDocs.current);

export const selectEDocsListItems = createSelector([selectEDocs], (eDocs) => eDocs.list);

export const selectEDocsItemById = (itemId: any) =>
    createSelector(selectEDocsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEDocsQueryItems = createSelector([selectEDocs], (eDocs) => eDocs.query);

export const selectEDocsCreatedItem = createSelector([selectEDocs], (eDocs) => eDocs.create);

export const selectEDocsUpdatedItem = createSelector([selectEDocs], (eDocs) => eDocs.update);

export const selectEDocsReadItem = createSelector([selectEDocs], (eDocs) => eDocs.read);

export const selectEDocsDeletedItem = createSelector([selectEDocs], (eDocs) => eDocs.delete);

export const selectSearchedItems = createSelector([selectEDocs], (eDocs) => eDocs.search);

export const selectEDocsItemsCount = createSelector([selectEDocs], (eDocs) => eDocs.count);

export const selectEDocsItemsFilter = createSelector([selectEDocs], (eDocs) => eDocs.filter);